import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';

interface BaseTransparencyOptionProps {
  isChecked: boolean;
  isDisabled: boolean;
  onToggleOption(): void;
}

export function BaseTransparencyOption({isDisabled = false, ...props}: BaseTransparencyOptionProps): ReactElement {
  const onClickHandler = (): void => {
    props.onToggleOption();
  };

  return (
    <ContextualMenuToggleOption
      id="item-transparency-option"
      label={window.i18next.t('pmwjs_transparency')}
      isChecked={props.isChecked}
      isDisabled={isDisabled}
      onClick={onClickHandler}
    />
  );
}
